import { render, staticRenderFns } from "./EditTrainee.vue?vue&type=template&id=40f3cd26&scoped=true&"
import script from "./EditTrainee.vue?vue&type=script&lang=js&"
export * from "./EditTrainee.vue?vue&type=script&lang=js&"
import style0 from "./EditTrainee.vue?vue&type=style&index=0&id=40f3cd26&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3cd26",
  null
  
)

export default component.exports